import * as React from 'react';
import './index.css';
import Summary from './summary';
import Htri from './htri';
import Erc from './erc';
import Eec from './eec';
import Iws from './iws';
import Ag from './ag';
import Ji from './ji';
import Spe from './spe';
import Rabs from './rabs';
import Urls from '@/config/url';
import https from '@/utils/ajaxUtils';
import { message, Popover, Radio, Space } from 'antd';
import CommonUtils from '../../../../../utils/commonUtils';

class ResultDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            type: null,
            selectMenu: 'summary',
            childData: null,
            detail: null,
            contentBaseData: null, // 大json原始数据
            dataForSelect: [], // 用于左上角的下拉数据
            dataList: [], // 具体要显示的内容数组 (c1 c2 这种,通过传过来的content label 匹配查找)
            data: null, // 具体左侧menu 选中的右侧要显示的内容
            classSlected: null, // 传过来的
            catergorySlected: null, // 传过来的
            catergorySlectedObj: null,
            contactInfo: null,
            kpIndex: -1,
            tcIndex: -1,
            selectedClass: null
        };
    }
    UNSAFE_componentWillMount() {
        // 获取传过来的4个参数  (详情id, class label(字符串)=state的dataForSelect , catergorySlected(字符串))
        console.log('this.props.location.state: ', this.props.location.state);
        this.getContactInfo();
        // this.getWordDictList();
        if (this.props.location.state &&
            this.props.location.state.id &&
            this.props.location.state.type &&
            this.props.location.state.catergorylabel &&
            this.props.location.state.classSlected) {
            this.setState({
                id: this.props.location.state.id,
                kpIndex: this.props.location.state.kpIndex,
                tcIndex: this.props.location.state.tcIndex,
                type: this.props.location.state.type,
                classSlected: this.props.location.state.classSlected,
                catergorySlected: this.props.location.state.catergorylabel,
                selectedClass: this.props.location.state.selectedClass,
            }, () => {
                console.log('this.state', this.state)
                this.getDetail();
            });
        } else {
            // 从参数中获取
            console.log(2222222222)
            let param = CommonUtils.getParamValue(window.location.search, 'param');
            if (param) {
                param = JSON.parse(decodeURIComponent(param));
                // console.log(param);
                this.setState({
                    id: param.id,
                    type: param.type,
                    classSlected: param.classSlected,
                    kpIndex: param.kpIndex,
                    tcIndex: param.tcIndex,
                    catergorySlected: param.catergorylabel,
                    selectedClass: param.selectedClass
                }, () => {
                    this.getDetail();
                });
            } else {
                message.error('参数错误!');
                return;
            }
        }
    }
    getDetail = async () => {
        const { id, kpIndex, tcIndex, type } = this.state;
        const param = { id, kpIndex, tcIndex }
        let res = null;
        if (type === 'case') {
            res = await https.get(Urls.getSimpleCaseKpDetail, param);
            console.log('newres', JSON.parse(res.data))
        }
        if (type === 'report') {
            res = await https.get(Urls.getReportKpDetail, param);
        }
        if (!res.success) {
            message.error('获取详情失败');
            return;
        }
        let dataList = this.state.dataList;
        if (res.success && res.data) {
            dataList = JSON.parse(res.data)
            this.setState({ dataList }, () => {
                this.findCatergoryObj();
                this.findDataBySelectMenu();
            });
        } else {
            message.error('获取数据失败');
            return;
        }
    }
    // 获取联系信息
    getContactInfo = async () => {
        const res = await https.get(Urls.getContactInfo, {});
        // console.log('联系信息: ', res);
        if (res.success) {
            this.setState({ contactInfo: res.data });
        }
    }
    // 根据当前的class初始化
    getBasicData = () => {
        this.findDataBySelectMenu();
        // let dataForSelect = this.state.dataForSelect;
        // let catergorySlected = this.state.catergorySlected;
        // // 根据传过来的classSlected 查找"catergory"
        // let dataList = dataForSelect.find((v) => { return v.label === catergorySlected });
        // if (dataList) {
        //   dataList = dataList.content;
        // }
        // // console.log('要显示的dataList: ', dataList);
        // this.setState({ dataList }, () => {
        //   this.findDataBySelectMenu();
        // });
    }

    // 通过selectMenu 查找data
    findDataBySelectMenu = () => {
        let selectMenu = this.state.selectMenu;
        // console.log('selectMenu: ', selectMenu);
        let dataList = this.state.dataList;
        // console.log('dataList: ', dataList);
        if (dataList && dataList.length > 0) {

            let find = dataList.find((v) => { return v.label === selectMenu });
            console.log(`find-${selectMenu}: `, find);
            if (find) {
                this.setState({ data: find });
            } else {
                this.setState({ data: null });
            }
        }
    }

    /**
     * 切换左侧菜单
     */
    selectedMenu = (id) => {
        // console.log('id: ', id);
        this.setState({
            selectMenu: id,
            childData: null,
            data: null
        }, () => {
            this.findDataBySelectMenu();
        });
    }

    /**
     * 进入子集
     */
    goChild = (childData) => {
        this.setState({
            childData
        });
    }

    /**
     * 子集回到上一级
     */
    goBack = () => {
        this.setState({
            childData: null
        });
    }
    catergoryChange = (e) => {
        let index = 0
        let selectedClass = this.state.selectedClass;
        console.log('selectedClass', selectedClass)
        for (let i = 0; i < selectedClass.length; i++) {
            if (selectedClass[i].label === e.target.value) {
                break;
            }
            index++
        }

        console.log('index', index);
        this.setState({
            catergorySlected: e.target.value,
            kpIndex: index,
            data: null
        }, () => {
            this.getDetail()
            console.log('this.state.dada', this.state.data)
        });
    }
    findCatergoryObj = () => {
        let catergorySlected = this.state.catergorySlected;
        let selectedClass = this.state.selectedClass;
        let find = selectedClass.find(v => v.label === catergorySlected);
        if (find) {
            this.setState({ catergorySlectedObj: find });
        } else {
            this.setState({ catergorySlectedObj: null });
        }

    }
    back = () => {
        // window.history.back();
        let param = {
            id: this.state.id,
            type: this.state.type,
            // catergorylabel: data.label,
            tcIndex: this.state.tcIndex,
            selected: this.props.location.state.selected,
            selectedClass: this.props.location.state.selectedClass
        }
        this.props.history.push({ pathname: "/service/result", state: param });
    }
    render() {
        const content = () => {
            let selectedClass = this.state.selectedClass;
            // console.log('dataForSelect: ', dataForSelect);
            if (!selectedClass || selectedClass.length <= 0) {
                return [];
            }
            let returnData = (
                <Radio.Group onChange={this.catergoryChange} value={this.state.catergorySlected}>
                    <Space direction="vertical">
                        {
                            selectedClass.map(v => {
                                return <Radio key={v.label} value={v.label}>{v.label}: {v.label_disp}</Radio>;
                            })
                        }
                    </Space>
                </Radio.Group>
            );
            return returnData;
        };
        return (
            <div className="index-content">
                <div className="result-detail-top">
                    <div className="back" onClick={this.back}></div>
                    <Popover content={content()} placement="bottomLeft" title="" trigger="click">
                        <div className="change"></div>
                    </Popover>
                    <div className="current">{this.state.catergorySlected}</div>
                    <div className="intro">{this.state.catergorySlectedObj?.label_disp}</div>
                </div>
                <div className="result-detail-content">
                    <div className="menu">
                        <div onClick={() => { this.selectedMenu('summary'); }} className={"menu-item" + (this.state.selectMenu === 'summary' ? ' selected' : '')} id="0">summary</div>
                        <div onClick={() => { this.selectedMenu('htri'); }} className={"menu-item" + (this.state.selectMenu === 'htri' ? ' selected' : '')} id="htri">Historical Trend of Research Interest</div>
                        <div onClick={() => { this.selectedMenu('erc'); }} className={"menu-item" + (this.state.selectMenu === 'erc' ? ' selected' : '')} id="erc">Entities Representing Context</div>
                        <div onClick={() => { this.selectedMenu('eec'); }} className={"menu-item" + (this.state.selectMenu === 'eec' ? ' selected' : '')} id="eec">Entities Enriched in Context</div>
                        <div onClick={() => { this.selectedMenu('asc_genes'); }} className={"menu-item" + (this.state.selectMenu === 'asc_genes' ? ' selected' : '')} id="asc_genes">Associated Genes</div>
                        <div onClick={() => { this.selectedMenu('spe'); }} className={"menu-item" + (this.state.selectMenu === 'spe' ? ' selected' : '')} id="spe">Signaling Pathway Enrichment</div>
                        <div onClick={() => { this.selectedMenu('iws'); }} className={"menu-item" + (this.state.selectMenu === 'iws' ? ' selected' : '')} id="iws">Index of Well-Studied</div>
                        <div onClick={() => { this.selectedMenu('rabs'); }} className={"menu-item" + (this.state.selectMenu === 'rabs' ? ' selected' : '')} id="rabs">Representative abstracts</div>
                        <div onClick={() => { this.selectedMenu('ji'); }} className={"menu-item" + (this.state.selectMenu === 'ji' ? ' selected' : '')} id="ji">Journal Information</div>
                        {/* <div onClick={() => { this.selectedMenu('9'); }} className={"menu-item" + (this.state.selectMenu === '9' ? ' selected' : '')} id="9">Do you want to train a neuron?</div> */}
                    </div>
                    {
                        this.state.data &&
                        <React.Fragment>
                            {
                                this.state.selectMenu === 'summary' &&
                                <div className="content">
                                    <div className="title">{this.state.data.label_disp}</div>
                                    <div className="cnt" style={{ whiteSpace: 'pre-wrap' }}>
                                        <React.Fragment>
                                            <Summary content={this.state.data.content} />
                                        </React.Fragment>
                                    </div>
                                </div>
                            }

                            {
                                this.state.selectMenu === 'htri' &&
                                <div className="content">
                                    <div className="title">{this.state.data.label_disp}</div>
                                    <div className="cnt">
                                        <React.Fragment>
                                            <Htri content={this.state.data.content} />
                                            {/* <img src="/img/result-detail-ex2.png" alt="" /> */}
                                            {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget. </p> */}
                                        </React.Fragment>
                                    </div>
                                </div>
                            }
                            {
                                this.state.selectMenu === 'erc' &&
                                <div className="content">
                                    <div className="title">{this.state.data.label_disp}</div>
                                    <div className="cnt">
                                        <React.Fragment>
                                            <Erc content={this.state.data.content} />
                                        </React.Fragment>
                                    </div>
                                </div>
                            }
                            {
                                this.state.selectMenu === 'eec' &&
                                <div className="content">
                                    <div className="title">{this.state.data.label_disp}</div>
                                    <div className="cnt">
                                        <React.Fragment>
                                            <Eec content={this.state.data.content} />
                                        </React.Fragment>
                                    </div>
                                </div>
                            }
                            {
                                this.state.selectMenu === 'asc_genes' && this.state.data &&
                                <Ag data={this.state.data} />
                            }
                            {
                                this.state.selectMenu === 'spe' && this.state.data &&
                                <Spe data={this.state.data} />
                            }
                            {
                                this.state.selectMenu === 'iws' && this.state.data &&
                                <Iws data={this.state.data} />

                            }
                            {
                                this.state.selectMenu === 'rabs' &&
                                <div className="content">
                                    <div className="title">{this.state.data.label_disp}</div>
                                    <div className="cnt">
                                        <p>
                                            <Rabs content={this.state.data.content} />
                                        </p>
                                    </div>
                                </div>
                            }
                            {
                                this.state.selectMenu === 'ji' &&
                                <div className="content">
                                    <div className="title">{this.state.data.label_disp}</div>
                                    <div className="cnt">
                                        <Ji content={this.state.data.content} />
                                    </div>
                                </div>
                            }
                        </React.Fragment>
                    }
                    {
                        this.state.selectMenu === '9' &&
                        <div className="content" style={{ overflow: 'unset' }}>
                            <div className="dyw-title">Do you want to train Neural Networks ?</div>
                            <div className="dyw-con">
                                <div className="dyw-name">TWiRLs</div>
                                <div className="dyw-txt">棍棍</div>
                            </div>
                            <div className="dyw-c">
                                <p style={{ fontSize: "0.16rem", lineHeight: "0.32rem", textAlign: 'justify', textIndent: '0.35rem' }}>
                                    如何快速全面获得一个特定领域相关的所有知识内容，这是一个亟需解决的问题。通过关键词的搜索，
                                    只是限制了搜索范围获得小部分内容。我们相信不同主题领域之间的内容是非独立，相互连接的。
                                </p>
                                <p style={{ fontSize: "0.16rem", lineHeight: "0.32rem", textAlign: 'justify', textIndent: '0.35rem' }}>
                                    在一个特定领域的某一定研究方向中，涵盖了各种不同面向的知识内容；这些知识内容可以构成一个多维空间，
                                    就是我们所谓的知识颗粒（包含Historical Trend of Research Interest，Entities Representing
                                    Context，Associated Genes，Signaling Pathway Enrichment，Index of Well-Studied 等若干
                                    方面的知识）。特定的数字化感知神经元可以由选定的知识颗粒训练获得，并且数字化神经元能自动阅读给定的文章，
                                    感知其中的知识分布和信息量因此也可以生成多个不同的内容感知神经元。同时，特定主题可以产生多个KPs，因此也可
                                    以生成多个不同的内容感知神经元，这些神经元可以按照特定方式联结，构成神经网络，该神经网络可以应用于深度理解
                                    文本的复杂内容，提取关键内容构建机制性模型。
                                </p>
                            </div>
                            <div className="dyw-bto">
                                <div className="dyw-w">如果您想训练一个神经网络，请联系我们：</div>
                                <div className="dyw-b">
                                    <img src={this.state.contactInfo.qrCodeBase64} style={{ width: '0.63rem', height: '0.69rem' }} alt="" />
                                    <div className="dyw-t">
                                        <div className="dyw-text">联系人：{this.state.contactInfo.person}</div>
                                        <div className="dyw-text">联系电话：{this.state.contactInfo.mobile}</div>
                                        <div className="dyw-text">联系地址：{this.state.contactInfo.address}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default ResultDetail;
